import { CHARSET_CLEARTYPE_RGB_BOLD, CHARSET_ALPHANUMERIC, CHARSET_NUMERIC, CHARSET_PRINTABLE_ASCII, GLYPH_HEIGHT, cropPixelImage, } from 'maplestory-glyph-decoder';
import { OWL_ROW_TEXT_LINE_Y, cropPreparedOwlCell, } from 'maplestory-owl-screenshot';
const NUMBER_CHARSET = CHARSET_NUMERIC + ',';
const PAGE_CHARSET = CHARSET_NUMERIC + '[]/';
// Preserve printable-ASCII tie-break order while excluding punctuation.
const PLAYER_NAME_CHARSET = CHARSET_ALPHANUMERIC;
function targetDefaults(key) {
    switch (key) {
        case 'itemName': return { profile: 'red', charset: CHARSET_CLEARTYPE_RGB_BOLD };
        case 'totalCount': return { profile: 'red', charset: NUMBER_CHARSET };
        case 'pageIndicator': return { profile: 'black', charset: PAGE_CHARSET };
        case 'bundle':
        case 'quantity': return { profile: 'black', charset: NUMBER_CHARSET };
        case 'price': return { profile: 'owl-price', charset: NUMBER_CHARSET };
        case 'id': return { profile: 'black', charset: PLAYER_NAME_CHARSET };
        case 'storeName': return { profile: 'black', charset: CHARSET_PRINTABLE_ASCII };
    }
}
function rowTarget(row, key) {
    const defaults = targetDefaults(key);
    const broadImage = cropPreparedOwlCell(row, key);
    // Cell rectangles already begin at their logical text origin. Only select
    // the shared 12px glyph line here.
    if (OWL_ROW_TEXT_LINE_Y + GLYPH_HEIGHT > broadImage.height) {
        throw new RangeError(`fixed lineY ${OWL_ROW_TEXT_LINE_Y} exceeds row cell height ${broadImage.height}`);
    }
    const image = cropPixelImage(broadImage, {
        x: 0,
        y: OWL_ROW_TEXT_LINE_Y,
        width: broadImage.width,
        height: GLYPH_HEIGHT,
    });
    return {
        key,
        rowIndex: row.index,
        image,
        profile: defaults.profile,
        charset: defaults.charset,
        ...(row.hasBillionPriceOverlap && (key === 'bundle' || key === 'price') ? { billionOverlapField: key } : {}),
    };
}
export function listOwlTextTargets(prepared) {
    const itemDefaults = targetDefaults('itemName');
    const totalDefaults = targetDefaults('totalCount');
    const pageDefaults = targetDefaults('pageIndicator');
    const targets = [
        { key: 'itemName', image: prepared.itemNameImage, ...itemDefaults },
        { key: 'totalCount', image: prepared.totalCountImage, ...totalDefaults },
        { key: 'pageIndicator', image: prepared.pageIndicatorImage, ...pageDefaults },
    ];
    const keys = ['id', 'storeName', 'bundle', 'price', 'quantity'];
    for (const row of prepared.rows)
        for (const key of keys)
            targets.push(rowTarget(row, key));
    return targets;
}
export function getOwlTextTarget(prepared, key, rowIndex) {
    if (key === 'itemName')
        return { key, image: prepared.itemNameImage, ...targetDefaults(key) };
    if (key === 'totalCount')
        return { key, image: prepared.totalCountImage, ...targetDefaults(key) };
    if (key === 'pageIndicator')
        return { key, image: prepared.pageIndicatorImage, ...targetDefaults(key) };
    if (rowIndex === undefined)
        throw new Error(`${key} requires rowIndex`);
    const row = prepared.rows.find((value) => value.index === rowIndex);
    if (!row)
        throw new RangeError(`row ${rowIndex} is unavailable`);
    return rowTarget(row, key);
}
//# sourceMappingURL=targets.js.map